import { render, staticRenderFns } from "./BJobs.vue?vue&type=template&id=96c764a0&scoped=true&"
import script from "./BJobs.vue?vue&type=script&lang=js&"
export * from "./BJobs.vue?vue&type=script&lang=js&"
import style0 from "./BJobs.vue?vue&type=style&index=0&id=96c764a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c764a0",
  null
  
)

export default component.exports